import type { RouteLocationNormalized } from 'vue-router';
import { route } from 'ziggy-js';

import { axios } from '@/helpers/axios';
import { useEtsyCircuitBreakerStore } from '@/helpers/etsy-circuit-breaker';

const routes = [
  {
    path: '/listing-audit/:id',
    name: 'listing-audit',
    component: () => import('@/modules/listing-audit/pages/Entry.vue'),
    meta: {
      title: 'eRank — Listing Audit',
      metaTags: [
        {
          name: 'description',
          content: 'Get a detailed analysis of your Etsy listing and see how it compares to the competition.',
        },
        {
          page_slug: 'listing-audit',
        },
      ],
      requiresAuth: true,
    },
    beforeEnter: async (to: RouteLocationNormalized) => {
      const listingId = to.params.id;

      const etsyCircuitBreakerStore = useEtsyCircuitBreakerStore();
      const response = await etsyCircuitBreakerStore.requestStatus();
      etsyCircuitBreakerStore.setActions(response.data);

      if (!listingId || Array.isArray(listingId)) {
        return { name: 'listing-not-found' };
      }

      try {
        const response = await axios.get<{ success: boolean }>(
          route('api.listing-audit.check-status', { id: listingId }),
        );

        if (!response.data.success) {
          return { name: 'listing-not-found' };
        }

        return true;
      } catch {
        return { name: 'listing-not-found' };
      }
    },
  },
  {
    path: '/listing-not-found',
    name: 'listing-not-found',
    component: () => import('@/modules/listing-audit/pages/ListingNotFound.vue'),
    meta: {
      title: 'eRank — Listing Not Found',
      requiresAuth: true,
    },
  },
];

export default routes;
